import React from 'react';
import { Outlet, useLocation } from 'react-router';

import styled from 'styled-components';

import { ErrorBoundaryReset } from 'components/error/ErrorBoundary';
import Navigation from 'components/templates/navigation/Navigation';
import TocNavigation from 'components/templates/navigation/TocNavigation';

import useNavigation from 'hooks/menu/useNavigation';

import Footer from '../../footer/Footer';
import LeftSideBar from '../../header/web/LeftSideBar';
import { LayoutWrapper } from './BaseLayout';

const PastLayout = () => {
  const location = useLocation();
  let locationPathName = location.pathname;
  const { navigation } = useNavigation();

  return (
    <LayoutWrapper id="page-content-wrapper">
      <LayoutContainer>
        {/* 사이드 메뉴 */}
        <LeftSideBar />
        <LayoutContents className="inavi_content" $path={locationPathName}>
          {/* 네비게이션 */}
          {navigation !== null && navigation[0].title !== '' && <Navigation />}
          <ErrorBoundaryReset>
            <Outlet />
          </ErrorBoundaryReset>
        </LayoutContents>
        {/* 목차 */}
        <TocNavigation />
      </LayoutContainer>
      {locationPathName !== '/document' && <Footer />}
    </LayoutWrapper>
  );
};

export default PastLayout;

export const LayoutContainer = styled.div`
  display: flex;
  flex-direction: row;
  width: 100%;
  // max-width: 1280px;
  max-width: 1440px;
  margin: 0px auto;
  padding: 0 24px 0;
  height: 100%;
  flex: 1;

  @media screen and (max-width: 768px) {
    padding: 0;
  }
`;

const LayoutContents = styled.div`
  flex: 1;
  min-width: 0;
  min-height: ${({ $path }) => ($path.includes('/sign-up') ? 'auto' : '90vh')};
`;
